import { createContext, useContext } from 'react';
import type { useChatDialogRealtime } from '@/features/chatDialogRealtime/model/useChatDialogRealtime';

/** Состояние обновлений переписки приложения */
export const AppChatRealtimeContext = createContext<ReturnType<typeof useChatDialogRealtime> | null>(null);

/** Получает состояние общей подписки поддержки */
export const useAppChatRealtime = () => {
    const value = useContext(AppChatRealtimeContext);

    if (!value) throw new Error('Не найден провайдер переписки приложения');
    return value;
};
